import React from 'react'
import { Pagination as AntPagination } from 'antd'
import { PaginationProps as AntPaginationProps } from 'antd/lib/pagination'

type Props = AntPaginationProps

export const Pagination: React.FC<Props> = ({
  defaultCurrent = 1,
  className,
  current,
  onChange,
  total,
  showSizeChanger,
  onShowSizeChange,
  disabled,
  hideOnSinglePage,
  pageSize = 10,
  size,
  pageSizeOptions
}) => {
  const controlledProps = {
    ...(current && { current }),
    ...(onChange && { onChange })
  }
  return (
    <AntPagination
      className={className}
      defaultCurrent={defaultCurrent}
      disabled={disabled}
      showSizeChanger={showSizeChanger}
      onShowSizeChange={onShowSizeChange}
      hideOnSinglePage={hideOnSinglePage}
      pageSize={pageSize}
      size={size}
      total={total}
      pageSizeOptions={pageSizeOptions}
      {...controlledProps}
    />
  )
}
